import enUS from './en-US.json';
import frFR from './fr-FR.json';

export default {
  'en-US': enUS,
  'fr-FR': frFR,
};
